import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/factionProfile/faction-profile.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/services/client/api-client.ts");
